/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

interface Props {
  idOportunidade: string;
  codigoResultado: number;
  justificativa: string;
  usuarioComercial: boolean;
}

export function useResultadoAnalise() {
  const postData = async (props: Props) => {
    const ANEXAR_LAUDO = `${backofficeEnviroment}/common/backoffice/resultado-analise/v1`;
    const { data } = await instance.put(ANEXAR_LAUDO, {
      idOportunidade: props.idOportunidade,
      codigoResultado: props.codigoResultado,
      justificativa: props.justificativa,
      usuarioComercial: props.usuarioComercial,
    });
    return data;
  };

  const mutation = useMutation(postData, {
    onSuccess: () => {
      toast.success("Resultado enviado com sucesso!");
    },
    onError: (error: any) => {
      toast.error(
        `Erro ao enviar resultado. Motivos: ${error.response.data.notifications.map(
          (item: any) => item?.message
        )} `,
        { autoClose: 10000 }
      );
    },
  });

  return mutation;
}
